import PropTypes from 'prop-types';
// import NumericInput from 'react-numeric-input';
import React, { Component } from 'react';
import { Algorithms } from 'enums';
import styles from './style';

export default class AlgorithmToggle extends Component {

  // eslint-disable-next-line no-undef
  static propTypes = {
    // state props
    // BC: PropTypes.bool.isRequired,
    // BT: PropTypes.bool.isRequired,
    // FC: PropTypes.bool.isRequired,
    // MAC: PropTypes.bool.isRequired,
    // m: PropTypes.number.isRequired,
    // mWC: PropTypes.bool.isRequired,
    // STR2: PropTypes.bool.isRequired,
    // dispatch props
    toggleActive: PropTypes.func.isRequired,
    activeAlgorithms: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { value: 'Backbone' };

    this.props.toggleActive(Algorithms.BT);
    this.handleChange = this.handleChange.bind(this);
  }

  // constructor(props) {
  //   super(props);
  //   this.state = { value: 'Backbone' };

  //   this.props.toggleActive(Algorithms.BT);
  // }

  /* event handlers */


  componentWillReceiveProps(nextProps) {
    console.log(nextProps.activeAlgorithms);
    const algos = nextProps.activeAlgorithms;
    if (algos.get('Backbone').get('isActive')) {
      this.setState({ value: 'Backbone' });
    } else if (algos.get('mWC').get('isActive')) {
      if (algos.get('mWC').get('isActive') === 4) {
        this.setState({ value: '4wC' });
      } else if (algos.get('mWC').get('isActive') === 3) {
        this.setState({ value: '3wC' });
      } else {
        this.setState({ value: '2wC' });
      }
    } else if (algos.get('GAC').get('isActive')) {
      this.setState({ value: 'GAC' });
    } else {
      this.setState({ value: 'Unary' });
    }
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
    console.log(event.target.value);
    const algo = event.target.value;

    // updates the algorithms that are being used
    if (algo === 'Unary') {
      this.state = this.props.toggleActive(Algorithms.Unary);
    } else if (algo === 'GAC') {
      this.state = this.props.toggleActive(Algorithms.STR2);
    } else if (algo === '2wC') {
      this.state = this.props.toggleActive(Algorithms.mWC, 2);
    } else if (algo === '3wC') {
      this.state = this.props.toggleActive(Algorithms.mWC, 3);
    } else if (algo === '4wC') {
      this.state = this.props.toggleActive(Algorithms.mWC, 4);
    } else if (algo === 'Backbone') {
      this.state = this.props.toggleActive(Algorithms.BT);
    }
  }

  render() {
    return (
      <div className={styles['border']}>
        <div className={styles['header']}>
          <h1 className={styles['consistency_drop']}>Consistency</h1>
          <div className={styles['consistency_drop']}>
            <select value={this.state.value} onChange={this.handleChange}>
              <option value="Unary">Unary</option>
              <option value="GAC">GAC</option>
              <option value="2wC">2wC</option>
              <option value="3wC">3wC</option>
              <option value="4wC">4wC</option>
              <option value="Backbone">Backbone</option>
            </select>
          </div>
        </div>
        <div className={styles['holders']}>
          <div className={styles['table_container']}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <div className={styles['unary']} />
                  </td>
                  <td>Unary Constraint</td>
                </tr>
                <tr>
                  <td>
                    <div className={styles['gac']} />
                  </td>
                  <td>GAC (STR2)</td>
                </tr>
                <tr>
                  <td>
                    <div className={styles['two_wc']} />
                  </td>
                  <td>2wiseConsistency (2wC)</td>
                </tr>
                <tr>
                  <td>
                    <div className={styles['three_wc']} />
                  </td>
                  <td>3wiseConsistency (3wC)</td>
                </tr>
                <tr>
                  <td>
                    <div className={styles['four_wc']} />
                  </td>
                  <td>4wiseConsistency (4wC)</td>
                </tr>
                <tr>
                  <td>
                    <div className={styles['backbone']} />
                  </td>
                  <td>Backbone</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/solve_panel/AlgorithmToggle.jsx